import { useEffect, useRef } from 'react'

export const useFetchInterval = ({ call, timeout }) => {
	const intervalRef = useRef()

	useEffect(() => {
		intervalRef.current = setInterval(() => {
			call()
		}, timeout)
		return () => {
			clearInterval(intervalRef.current)
		}
	}, [call, timeout])

	return { clear: () => clearInterval(intervalRef.current) }
}
